import { createFileRoute, Link } from "@tanstack/react-router";
import { useStore } from "@/lib/store-context";
import { ProductCard } from "@/components/store/product-card";
import { Container, meta } from "@/components/store/page-parts";

export const Route = createFileRoute("/products/category/$categorySlug")({
  head: ({ params }) => {
    return meta(`Category: ${params.categorySlug} — betteraccess.store`, `Shop verified digital products with clear delivery.`);
  },
  component: Category,
});

function Category() {
  const { categorySlug } = Route.useParams();
  const { products, categories } = useStore();
  const cat = categories.find(c => c.slug === categorySlug || c.id === categorySlug);
  const list = products.filter(p => p.categorySlug === categorySlug || p.category_id === categorySlug);

  return (
    <Container className="py-8 sm:py-10">
      <p className="text-xs">
        <Link to="/products" className="text-primary">
          Products
        </Link>{" "}
        / {cat?.name ?? categorySlug}
      </p>
      <h1 className="mt-5 text-3xl font-black sm:text-4xl">{cat?.name ?? "Digital products"}</h1>
      <p className="mt-3 text-muted-foreground">{cat?.copy ?? "Every listing is checked and ready for clear delivery."}</p>
      {list.length ? (
        <div className="mt-9 grid grid-cols-2 gap-3 md:grid-cols-3 lg:grid-cols-4 lg:gap-5">
          {list.map(p => (
            <ProductCard key={p.slug} product={p} />
          ))}
        </div>
      ) : (
        <div className="py-24 text-center">
          <h2 className="text-xl font-bold">No products in this category yet</h2>
          <p className="mt-2 text-sm text-muted-foreground">Check back soon or browse our full catalog.</p>
        </div>
      )}
    </Container>
  );
}
